
import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import HeaderLogo  from "../structure/headerlogo";
import CommonIcon from '../common/customicon';

const ComplianceMonitoring = () => {
  const compChartRef = useRef(null);

  useEffect(() => {
    if (compChartRef.current) {
      new Chart(compChartRef.current, {
        type: 'radar',
        data: {
          labels: ['QC Submissions', 'Brand Guidelines', 'Royalty Payments', 'Territory Limits', 'Product Approvals', 'Reporting'],
          datasets: [
            {label:'Current', data:[92,78,85,95,68,88], backgroundColor:'rgba(59,130,246,0.2)', borderColor:'#3B82F6'},
            {label:'Target', data:[100,100,100,100,100,100], backgroundColor:'rgba(16,185,129,0.1)', borderColor:'#10B981', borderDash:[5,5]}
          ]
        },
        options: { responsive:true, scales:{r:{min:0,max:100}} }
      });
    }
  }, []);

  return (
    <div className="main-content" style={{ paddingTop: 64 }}>
       <HeaderLogo />
      <div className="page-content">
        <div className="container-fluid">
          <div id="table_height">
    <div className="bg-gray-50 min-h-screen">
      <div className=" ">
        <div className="flex items-center justify-between mb-6">
          {/* <div>
            <h1 className="text-3xl font-bold text-gray-900">Compliance Monitoring</h1>
            <p className="text-gray-500 mt-1">Track quality control, approval workflows, brand guidelines adherence</p>
          </div> */}
          <div className="d-flex align-items-center mb-2">
              <div className="bg-primary text-white rounded p-2 me-3">
                <CommonIcon iconName="ShieldCheck" size={"24px"}  color="#fff" />
              </div>
              <div className="flex-grow-1">
                <h1 className="h3 mb-0 fw-bold">Compliance Monitoring</h1>
                <p className="text-muted mb-0 small">Track quality control, approval workflows, brand guidelines adherence</p>
              </div>
</div>
          <button className="bg-blue-600 text-white px-4 py-2 rounded-lg">Run Compliance Check</button>
        </div>

        {/* Overall Score */}
        <div className="grid grid-cols-4 gap-4 mb-6">
          <div className="bg-white rounded-xl shadow p-2 text-center">
            <div className="w-20 h-20 mx-auto rounded-full border-8 border-green-500 flex items-center justify-center">
              <span className="text-2xl font-bold text-green-700">87%</span>
            </div>
            <p className="text-sm text-gray-500 mt-2">Overall Compliance</p>
          </div>
          <div className="bg-white rounded-xl shadow p-2">
            <p className="text-sm text-gray-500">Quality Control Submissions</p>
            <p className="text-2xl font-bold">48 / 52</p>
            <div className="w-full bg-gray-200 rounded-full h-2 mt-2"><div className="bg-green-500 h-2 rounded-full" style={{width:'92%'}}></div></div>
            <p className="text-xs text-gray-400 mt-1">4 overdue submissions</p>
          </div>
          <div className="bg-white rounded-xl shadow p-2">
            <p className="text-sm text-gray-500">Brand Guideline Violations</p>
            <p className="text-2xl font-bold text-red-600">6</p>
            <div className="w-full bg-gray-200 rounded-full h-2 mt-2"><div className="bg-red-500 h-2 rounded-full" style={{width:'12%'}}></div></div>
            <p className="text-xs text-gray-400 mt-1">3 resolved, 3 open</p>
          </div>
          <div className="bg-white rounded-xl shadow p-2">
            <p className="text-sm text-gray-500">Pending Approvals</p>
            <p className="text-2xl font-bold text-yellow-600">11</p>
            <div className="w-full bg-gray-200 rounded-full h-2 mt-2"><div className="bg-yellow-500 h-2 rounded-full" style={{width:'22%'}}></div></div>
            <p className="text-xs text-gray-400 mt-1">5 high priority</p>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-6 mb-6">
          {/* Compliance by Licensee */}
          <div className="col-span-2 bg-white rounded-xl shadow p-6">
            <h5 className="text-lg font-semibold mb-4">Compliance Score by Licensee</h5>
            <div className="space-y-4">
              <div className="flex items-center gap-4">
                <span className="w-40 text-sm font-medium">Summit Ridge Merch</span>
                <div className="flex-1 bg-gray-200 rounded-full h-6 relative">
                  <div className="bg-green-500 h-6 rounded-full flex items-center justify-end pr-2" style={{width:'95%'}}><span className="text-xs text-white font-bold">95%</span></div>
                </div>
                <span className="text-green-600 text-sm">Excellent</span>
              </div>
              <div className="flex items-center gap-4">
                <span className="w-40 text-sm font-medium">Golden State Apparel</span>
                <div className="flex-1 bg-gray-200 rounded-full h-6 relative">
                  <div className="bg-green-500 h-6 rounded-full flex items-center justify-end pr-2" style={{width:'90%'}}><span className="text-xs text-white font-bold">90%</span></div>
                </div>
                <span className="text-green-600 text-sm">Good</span>
              </div>
              <div className="flex items-center gap-4">
                <span className="w-40 text-sm font-medium">Horizon Peak Retail</span>
                <div className="flex-1 bg-gray-200 rounded-full h-6 relative">
                  <div className="bg-green-500 h-6 rounded-full flex items-center justify-end pr-2" style={{width:'85%'}}><span className="text-xs text-white font-bold">85%</span></div>
                </div>
                <span className="text-green-600 text-sm">Good</span>
              </div>
              <div className="flex items-center gap-4">
                <span className="w-40 text-sm font-medium">Dreamlight Studios</span>
                <div className="flex-1 bg-gray-200 rounded-full h-6 relative">
                  <div className="bg-yellow-500 h-6 rounded-full flex items-center justify-end pr-2" style={{width:'72%'}}><span className="text-xs text-white font-bold">72%</span></div>
                </div>
                <span className="text-yellow-600 text-sm">Needs Attention</span>
              </div>
              <div className="flex items-center gap-4">
                <span className="w-40 text-sm font-medium">Pacific Coast Toys</span>
                <div className="flex-1 bg-gray-200 rounded-full h-6 relative">
                  <div className="bg-red-500 h-6 rounded-full flex items-center justify-end pr-2" style={{width:'58%'}}><span className="text-xs text-white font-bold">58%</span></div>
                </div>
                <span className="text-red-600 text-sm">At Risk</span>
              </div>
              <div className="flex items-center gap-4">
                <span className="w-40 text-sm font-medium">NovaTech Games</span>
                <div className="flex-1 bg-gray-200 rounded-full h-6 relative">
                  <div className="bg-red-500 h-6 rounded-full flex items-center justify-end pr-2" style={{width:'45%'}}><span className="text-xs text-white font-bold">45%</span></div>
                </div>
                <span className="text-red-600 text-sm">Critical</span>
              </div>
            </div>
          </div>

          {/* Compliance Breakdown */}
          <div className="bg-white rounded-xl shadow p-6">
            <h5 className="text-lg font-semibold mb-4">Compliance Areas</h5>
            <canvas ref={compChartRef} height="250"></canvas>
          </div>
        </div>

        {/* Open Issues */}
        <div className="bg-white rounded-xl shadow p-6">
          <h5 className="text-lg font-semibold mb-4">Open Compliance Issues</h5>
          <div className="space-y-3">
            <div className="flex items-center gap-4 p-4 border-l-4 border-red-500 bg-red-50 rounded-r-lg">
              <div><span className="bg-red-600 text-white px-2 py-1 rounded text-xs">Critical</span></div>
              <div className="flex-1">
                <p className="font-semibold text-sm">NovaTech Games — Missing QC submissions for 3 consecutive months</p>
                <p className="text-xs text-gray-500">Contract requires monthly quality control reports (Section 7.3). Last received: Dec 2025</p>
              </div>
              <div className="text-xs text-gray-400">Due: Jan 15</div>
              <button className="border px-3 py-1 rounded text-sm">Send Reminder</button>
            </div>
            <div className="flex items-center gap-4 p-4 border-l-4 border-red-500 bg-red-50 rounded-r-lg">
              <div><span className="bg-red-600 text-white px-2 py-1 rounded text-xs">Critical</span></div>
              <div className="flex-1">
                <p className="font-semibold text-sm">Pacific Coast Toys — Logo usage violation on packaging</p>
                <p className="text-xs text-gray-500">Brand logo resized below minimum 1" requirement. Found on 3 product lines.</p>
              </div>
              <div className="text-xs text-gray-400">Found: Mar 10</div>
              <button className="border px-3 py-1 rounded text-sm">View Details</button>
            </div>
            <div className="flex items-center gap-4 p-4 border-l-4 border-yellow-500 rounded-r-lg">
              <div><span className="bg-yellow-500 text-white px-2 py-1 rounded text-xs">Warning</span></div>
              <div className="flex-1">
                <p className="font-semibold text-sm">Dreamlight Studios — Product approval pending for 45 days</p>
                <p className="text-xs text-gray-500">New product line submitted Feb 12 — contract requires approval within 30 days (Section 5.1)</p>
              </div>
              <div className="text-xs text-gray-400">Overdue: 15d</div>
              <button className="bg-green-600 text-white px-3 py-1 rounded text-sm">Approve</button>
            </div>
          </div>
        </div>
      </div>
    </div></div></div></div></div>
  );
};

export default ComplianceMonitoring;
